/** @format */
import { css } from 'styled-components';

import { largeTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    margin-bottom: var(--layout-spacing-48);
    padding: var(--layout-spacing-48) 0;
    background-color: var(--colors-surface-primary);

    .kit-section-header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--layout-spacing-8);
        margin-bottom: var(--layout-spacing-32);
        text-align: left;
    }

    .kit-section-eyebrow-row {
        display: flex;
        align-items: center;
        gap: var(--layout-spacing-12);
    }

    .kit-section-eyebrow {
        ${theme.typography.caption_highlight}
        text-transform: uppercase;
        color: var(--colors-text-tertiary);
    }

    /*
     * Feather's H2 ships with 24 of its own margin below it, which the
     * header's flex gap of 8 then adds to. Taken down to 8 here so the
     * heading and the paragraph explaining it read as one introduction.
     */
    .kit-section-heading {
        margin-bottom: var(--layout-spacing-8);
    }

    .kit-section-intro {
        ${theme.typography.body_normal}
        color: var(--colors-text-secondary);
        max-width: 64rem;
    }

    /*
     * The height every cell of the grid is built from. A tall card is two
     * of these, the wide card and the lead card's remaining third are one
     * each, and a stat tile is half of one — see the grid-template-rows
     * below, which is where that arithmetic actually happens. Anchored to
     * an existing spacing token rather than a value invented for this grid,
     * the same rule every other size in this stylesheet follows.
     */
    --kit-intel__unit: var(--layout-spacing-96);

    .kit-section-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        /*
         * minmax rather than a bare height keeps every cell honest about the
         * unit it is meant to be while still letting a card grow if its own
         * content — a longer blurb, an extra model row — needs more room
         * than the unit allows, rather than clipping it to fit.
         */
        grid-template-rows:
            minmax(calc(var(--kit-intel__unit) * 2), auto)
            minmax(var(--kit-intel__unit), auto)
            minmax(calc(var(--kit-intel__unit) * 0.5), auto);
        gap: var(--layout-spacing-16);
    }

    /* Column 1, spanning both tall rows — three units tall in total. */
    .kit-section-lead {
        grid-column: 1;
        grid-row: 1 / span 2;
    }

    .kit-section-card--0 {
        grid-column: 2;
        grid-row: 1;
    }

    .kit-section-card--1 {
        grid-column: 3;
        grid-row: 1;
    }

    /* The wide card, under the two tall ones, spanning both their columns. */
    .kit-section-card--2 {
        grid-column: 2 / span 2;
        grid-row: 2;
    }

    .kit-section-stat--0 {
        grid-column: 1;
        grid-row: 3;
    }

    .kit-section-stat--1 {
        grid-column: 2;
        grid-row: 3;
    }

    .kit-section-stat--2 {
        grid-column: 3;
        grid-row: 3;
    }

    /*
     * The grid is a bento box that only reads as one on a screen wide enough
     * to see all three columns at once. Below large tablet it is abandoned
     * for a single column in reading order: the lead card, then the three
     * theme cards in the order the export wrote them, then the three stats —
     * which is already the DOM order, so nothing here has to reorder
     * anything, only stop placing each piece explicitly and let every card
     * take the height its own content wants.
     */
    ${largeTablet(css`
        .kit-section-grid {
            grid-template-columns: minmax(0, 1fr);
            grid-template-rows: none;
            gap: var(--layout-spacing-16);
        }

        .kit-section-lead,
        .kit-section-card--0,
        .kit-section-card--1,
        .kit-section-card--2,
        .kit-section-stat--0,
        .kit-section-stat--1,
        .kit-section-stat--2 {
            grid-column: 1;
            grid-row: auto;
        }
    `)}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
